export default __webpack_public_path__ + "static/media/roundabout-right.9ad1a37c.svg";